export default "__VITE_ASSET__1b0e640a__"